//Please add the language resource
const waybill = {
  fetchNo: 'fetchNo',
  tknum: 'tknum',
  vbeln: 'vbeln',
  shtyp: 'shtyp',
  tplst: 'tplst',
  bezei: 'bezei',
  ernam: 'ernam',
  erdat: 'erdat',
  erzet: 'erzet',
  aedat: 'aedat',
  aezet: 'aezet',
  vsbed: 'vsbed',
  vtext: 'vtext',
  route: 'route',
  name2: 'name2',
  signi: 'signi',
  dpreg: 'dpreg',
  dplbg: 'dplbg',
  dplen: 'dplen',
  dpabf: 'dpabf',
  zxzjh: 'zxzjh',
  dtdis: 'dtdis',
  dareg: 'dareg',
  dalbg: 'dalbg',
  dalen: 'dalen',
  tdlnr: 'tdlnr',
  name1: 'name1',
  addressD: 'addressD',
  name33D: 'name33D',
  bezei1: 'bezei1',
  address: 'address',
  name33: 'name33',
  telNumber: 'telNumber',
  zyyzd1: 'zyyzd1',
  zyyzd2: 'zyyzd2',
  zyyzd3: 'zyyzd3',
  zyyzd4: 'zyyzd4',
  zyyzd5: 'zyyzd5',
  dealTime: 'dealTime',
  dealStatus: 'dealStatus',
  dealCount: 'dealCount',
  dealResult: 'dealResult',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
  detail: {
    tknum: 'tknum',
    tpnum: 'tpnum',
    vbeln: 'vbeln',
    posnr: 'posnr',
    bstkd: 'bstkd',
    zfwfc: 'zfwfc',
    matnr: 'matnr',
    maktx: 'maktx',
    charg: 'charg',
    hsdat: 'hsdat',
    vfdat: 'vfdat',
    werks: 'werks',
    name1: 'name1',
    lgort: 'lgort',
    lgobe: 'lgobe',
    umrez: 'umrez',
    divLgmng: 'divLgmng',
    modLgmng: 'modLgmng',
    lgmng: 'lgmng',
    brgew: 'brgew',
    volum: 'volum',
    zyyzd1: 'zyyzd1',
    zyyzd2: 'zyyzd2',
    zyyzd3: 'zyyzd3',
    zyyzd4: 'zyyzd4',
    zyyzd5: 'zyyzd5'
  },
  msg: {}
};
export default waybill



// WEBPACK FOOTER //
// ./src/page/log/waybill/lang/waybill.en.js